var _toConsumableArray = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

module.exports.KEYOBJECT = Symbol('KEYOBJECT');
module.exports.PRIVATE_MEMBERS = Symbol('PRIVATE_MEMBERS');
module.exports.PUBLIC_MEMBERS = Symbol('PUBLIC_MEMBERS');
module.exports.THUMBPRINT_MATERIAL = Symbol('THUMBPRINT_MATERIAL');
module.exports.JWK_MEMBERS = Symbol('JWK_MEMBERS');
module.exports.KEY_MANAGEMENT_ENCRYPT = Symbol('KEY_MANAGEMENT_ENCRYPT');
module.exports.KEY_MANAGEMENT_DECRYPT = Symbol('KEY_MANAGEMENT_DECRYPT');
var USES_MAPPING = {
  sig: new Set(['sign', 'verify']),
  enc: new Set(['encrypt', 'decrypt', 'wrapKey', 'unwrapKey', 'deriveKey'])
};
var OPS = new Set([].concat(_toConsumableArray(USES_MAPPING.sig), _toConsumableArray(USES_MAPPING.enc)));
var USES = new Set(Object.keys(USES_MAPPING));
module.exports.USES_MAPPING = USES_MAPPING;
module.exports.OPS = OPS;
module.exports.USES = USES;